// especially useful for route loaders and other non-react async code
// for data that we want to cache and typically request once
export function createAsyncCache<T>(load: () => Promise<T>) {
  let value: T | undefined;
  let pending: Promise<T> | undefined;

  return {
    get current(): T | undefined {
      return value;
    },

    async get(force = false): Promise<T> {
      if (value !== undefined && !force) {
        return value;
      }

      if (pending && !force) {
        return pending;
      }

      pending = load()
        .then((result) => {
          value = result;
          return result;
        })
        .finally(() => {
          pending = undefined;
        });

      return pending;
    },

    clear() {
      value = undefined;
      pending = undefined;
    },
  };
}
